import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useRef, useEffect } from 'react'
import { change } from '../slicers/selectedStepSlicer'
import { add } from '../slicers/addedJobSlicer'
import { add as addStepTwo } from '../slicers/stepTwoSlicer'
import './steps.css'

const StepThree = () => {
  const callKey = useSelector((state) => state.keySlicer.value)
  const addedJob = useSelector((state) => state.addedJob.arr)
  const stepTwo = useSelector((state) => state.stepTwo.arr)
  const dispatch = useDispatch()
  
  const [step_input, setstep_input] = useState("");
  const [step_input2, setstep_input2] = useState("");
  const [showList, setshowList] = useState(false);
  const [list, setlist] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const wrapperRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
const [filteredList, setFilteredList] = useState([]);
  
  // Закрытие списка при клике вне
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setshowList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (list.length > 0) {
      // Если оба поля пустые — показываем все заказы
      if (!step_input && !step_input2) {
          setFilteredList(list);
          return;
      }
      
      // Если заказ уже выбран — не показываем список
      if (selectedOrder) return;
      
      const filtered = list.filter(item => {
          const parts = item.number.split('-');
          const leftPart = parts[0] || '';
          const rightPart = parts[1] || '';
          
          const leftMatch = step_input ? leftPart.includes(step_input) : true;
          const rightMatch = step_input2 ? rightPart.includes(step_input2) : true;
          
          return leftMatch && rightMatch;
      });
      setFilteredList(filtered);
      setshowList(true);
      }
    }, [step_input, step_input2, list]);

  function callList() {
    setIsLoading(true);
    let xhr = new XMLHttpRequest();
    let url = new URL(`${process.env.REACT_APP_BASEURL}work-order/by-machine-operation-type-id?OperationTypeId=${addedJob.operationTypeId}`);
    xhr.open('GET', url, true);
    xhr.setRequestHeader('authtoken', callKey);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.responseType = 'json';
    xhr.send();
    
    xhr.onload = () => {
      setIsLoading(false);
      if (xhr.status == 200) {
        setlist(xhr.response);
        setFilteredList(xhr.response);
      }
    };
    
    xhr.onerror = () => {
      setIsLoading(false);
    };
  }
  
  function JobItem() {
    if (step_input) {
      setIsLoading(true);
      const orderNumber = step_input2 ? `${step_input}-${step_input2}` : step_input;
      let xhr = new XMLHttpRequest();
      let url = new URL(`${process.env.REACT_APP_BASEURL}work-order/by-number?number=${orderNumber}`);
      xhr.open('GET', url, true);
      xhr.setRequestHeader('authtoken', callKey);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';
      xhr.send();
      
      xhr.onload = () => {
        setIsLoading(false);
        if (xhr.status == 200) {
          // console.log('📋 Заказ с сервера:', xhr.response);
          // console.log('📅 Дата заказа с сервера:', xhr.response.date);
          const result = xhr.response.id;
          for (const i of xhr.response.operations) {
            if (i.machineOperationType.id == addedJob.operationTypeId) {
              dispatch(addStepTwo(i));
            }
          }
          dispatch(add([2, result]));
          dispatch(add([7, orderNumber]));
          dispatch(add([9, xhr.response.date]));
          setSelectedOrder(xhr.response);
          dispatch(change(4));
        } else {
          alert('❌ Заказ не найден');
        }
      };
      
      xhr.onerror = () => {
        setIsLoading(false);
        alert('❌ Ошибка соединения');
      };
    }
  }
  
  const selectOrder = (order) => {
    // console.log('📋 Выбран заказ:', order);
    // console.log('📅 Дата заказа (сырые данные):', order.date);
    // console.log('📅 Тип даты:', typeof order.date);

    const parts = order.number.split('-');
    setstep_input(parts[0] || order.number);
    setstep_input2(parts[1] || '');
    setSelectedOrder(order);
    setshowList(false);
    setFilteredList([]); 
  };
  
  return (
    <div className="step-container">
      {/* Верхняя панель */}
      <div className="step-header">
        <button className="back-button" onClick={() => dispatch(change(2))}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#265c9d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Назад</span>
        </button>
        <div className="step-indicator">
          <span className="step-dot completed"></span>
          <span className="step-dot completed"></span>
          <span className="step-dot active"></span>
          <span className="step-dot"></span>
        </div>
      </div>
      
      {/* Заголовок */}
      <div className="step-title-section">
        <h1 className="step-title">Заказ на производство</h1>
        <p className="step-subtitle">
          Введите номер заказа или выберите из списка
        </p>
      </div>
      
      {/* Информация о выбранной операции */}
      {stepTwo?.machineOperationType && (
        <div style={{
          padding: '12px 16px',
          background: '#F1F5F9',
          borderRadius: '14px',
          marginBottom: '20px'
        }}>
          <p style={{ margin: 0, fontSize: '14px', color: '#64748B' }}>
            Операция: <strong style={{ color: '#0F172A' }}>{stepTwo.machineOperationType.name}</strong>
          </p>
        </div>
      )}
      
      {/* Кнопка камеры */}
      <div className="camera-section">
        <button className="camera-button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="2" y="5" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
            <circle cx="10" cy="10.5" r="3" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M6 3L7 2H13L14 3H17V5H3V3H6Z" fill="currentColor"/>
          </svg>
          <span>Сканировать QR-код</span>
        </button>
      </div>
      
      {/* Поля ввода */}
      <div className="order-input-group">
        <input
          className="order-input"
          placeholder="0000"
          value={step_input}
          onChange={(e) => {
            setstep_input(e.target.value);
            setSearchTerm(e.target.value);
            // Автоматически открываем список при вводе
            if (e.target.value) {
                if (list.length === 0) {
                    callList();
                }
                setshowList(true);
            } else {
                setshowList(false);
            }
          }}
          inputMode="numeric"
        />
        <span className="order-dash">—</span>
        <input
          className="order-input"
          placeholder="000000"
          value={step_input2}
          onChange={(e) => {
            setstep_input2(e.target.value);
            if (e.target.value && list.length === 0) {
                callList();
            }
          }}
          inputMode="numeric"
        />
      </div>

      {/* Кнопка очистки */}
      {(step_input || step_input2) && (
      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
        <button 
            onClick={() => {
                setstep_input('');
                setstep_input2('');
                setSearchTerm('');
                setFilteredList(list);
                setshowList(false);
            }}
            style={{
                padding: '8px 20px',
                background: '#F1F5F9',
                border: 'none',
                borderRadius: '12px',
                color: '#64748B',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
            }}
        >
            ✕ Очистить фильтр
        </button>
      </div>
      )}
      
      {/* Кнопка показать список */}
      <div ref={wrapperRef} style={{ position: 'relative' }}>
        <button 
            className="camera-button"
            onClick={() => {
                if (showList) {
                    // Если список открыт — закрываем
                    setshowList(false);
                } else {
                    // Если список закрыт — открываем
                    if (list.length === 0) {
                        callList();
                    } else {
                        setFilteredList(list);  // Показываем все заказы
                    }
                    setSelectedOrder(null);
                    setshowList(true);
                }
            }}
            style={{ marginBottom: showList ? '8px' : '16px', width: '100%' }}
        >

          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5 7L10 12L15 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>{showList ? 'Скрыть список' : 'Показать список заказов'}</span>
        </button>
        
        {/* Выпадающий список */}
        {showList && (
          <div className="dropdown-list">
            {isLoading ? (
              <div className="loading-state">
                <div className="spinner"></div>
                <p>Загрузка заказов...</p>
              </div>
            ) : filteredList.length > 0 ? (
              filteredList.map((item) => (
                <div
                  className="order-card"
                  key={item.id}
                  onClick={() => selectOrder(item)}
                >
                  <div className="order-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M3 5H17V16H3V5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                      <path d="M6 3V7M14 3V7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div className="order-info">
                    <h3 className="order-number">{item.number}</h3>
                    
                    <p className="order-date">
                      {item.date 
                      ? new Date(item.date).toLocaleDateString('ru-RU') 
                      : 'Дата не указана'}
                    </p>

                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#CBD5E1" strokeWidth="1.5"/>
                  <path d="M8 12H16" stroke="#CBD5E1" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <p>Заказы не найдены</p>
                <span>Попробуйте ввести номер вручную</span>
              </div>
            )}
          </div>
        )}
      </div>
      
      {/* Выбранный заказ */}
      {selectedOrder && (
        <div className="selected-order">
          <div className="selected-label">Выбранный заказ</div>
          <div className="selected-card">
            <div className="selected-icon">📋</div>
            <div className="selected-info">
              <h3>№{selectedOrder.number}</h3>
              {/* 🔥 ИСПРАВЛЕНО: берём дату из selectedOrder.date */}
              <p>от {selectedOrder.date 
                  ? (() => {
                      try {
                        // Пробуем разные форматы даты
                        const date = new Date(selectedOrder.date);
                        if (isNaN(date.getTime())) {
                          // Если не удалось распарсить — пробуем заменить пробелы на T
                          const fixedDate = selectedOrder.date.replace(' ', 'T');
                          return new Date(fixedDate).toLocaleDateString('ru-RU');
                        }
                        return date.toLocaleDateString('ru-RU');
                      } catch (e) {
                        // Если совсем не получается — показываем как есть
                        return selectedOrder.date;
                      }
                    })()
                  : 'дата не указана'}</p>
            </div>
            <div className="selected-check">✓</div>
          </div>
        </div>
      )}
            
      {/* Кнопка Далее */}
      <button 
        className={`continue-button ${step_input ? 'active' : ''}`}
        onClick={JobItem}
        disabled={!step_input || isLoading}
      >
        {isLoading ? (
          <span className="button-spinner"></span>
        ) : (
          <>
            <span>Продолжить</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </>
        )}
      </button>
    </div>
  );
};

export default StepThree;